<template>
  <Modal v-if="show" @close="close" @cancel="close">
    <h1 slot="header">
      Verification Required
    </h1>
    <div slot="body">
      <component
        :is="currentView"
        transition-mode="out-in"
        @transitionend.stop
        @reset="currentView = 'Reset'"
        @verify="currentView = 'Verify'"
      />
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/partials/Modal";
import Verify from "./Verify";
import Reset from "./Reset";

import Loader from "vue-spinner/src/BounceLoader";

export default {
  name: "auth-modal-two-factor",
  components: { Modal, Loader, Verify, Reset },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      code: null,
      reset: false,
      currentView: "Verify"
    };
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.loader-wrapper {
  display: inline-block;
}
</style>
